/** Vacaciones — Código de Trabajo GT: 15 días hábiles por año de servicio. Cálculo en cliente; persistencia en nomina-svc. */

export type ModalidadVacacion = 'ORDINARIA' | 'ADELANTO';

export type RegistroVacacion = {
  id: string;
  empleadoId: string;
  desde: string;
  hasta: string;
  dias: number;
  modalidad: ModalidadVacacion;
  nota?: string;
  registradoEn?: string;
};

export function aniosServicio(fechaIngreso?: string | null): number {
  if (!fechaIngreso) return 0;
  const ini = new Date(fechaIngreso + 'T00:00:00');
  if (Number.isNaN(ini.getTime())) return 0;
  const ms = Date.now() - ini.getTime();
  return Math.max(0, Math.floor(ms / (365.25 * 24 * 3600 * 1000)));
}

/** 15 días hábiles por año cumplido. */
export function diasDevengados(fechaIngreso?: string | null): number {
  return aniosServicio(fechaIngreso) * 15;
}

export function diasUsados(regs: RegistroVacacion[], empleadoId: string): number {
  return regs.filter(v => v.empleadoId === empleadoId).reduce((s, v) => s + Number(v.dias || 0), 0);
}

export function diasPendientes(regs: RegistroVacacion[], empleadoId: string, fechaIngreso?: string | null): number {
  return Math.max(0, diasDevengados(fechaIngreso) - diasUsados(regs, empleadoId));
}

export function diasEntre(desde: string, hasta: string): number {
  const a = new Date(desde + 'T00:00:00');
  const b = new Date(hasta + 'T00:00:00');
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime()) || b < a) return 0;
  return Math.floor((b.getTime() - a.getTime()) / 86400000) + 1;
}
